import { createContext, useContext, useState } from "react"
import type Operation from "~/types/serializers/Operation"

interface OperationContextType {
  operation: Operation
  expanded: boolean
  toggleExpanded: () => void
}

const OperationContext = createContext<OperationContextType | undefined>(
  undefined,
)

export const OperationProvider = ({
  operation,
  children,
  onExpand,
}: {
  operation: Operation
  children: React.ReactNode
  onExpand?: (expanded: boolean) => void
}) => {
  const [expanded, setExpanded] = useState(false)

  const toggleExpanded = () => {
    const newExpanded = !expanded
    setExpanded(newExpanded)
    onExpand?.(newExpanded)
  }

  return (
    <OperationContext.Provider value={{ operation, expanded, toggleExpanded }}>
      {children}
    </OperationContext.Provider>
  )
}

export const useOperation = () => {
  const context = useContext(OperationContext)
  if (context === undefined) {
    throw new Error("useOperation must be used within an OperationProvider")
  }
  return context
}
